"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayloadKeySerializer = exports.PayloadKey = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var PayloadKey;
(function (PayloadKey) {
    PayloadKey[PayloadKey["Amount"] = 0] = "Amount";
    PayloadKey[PayloadKey["Authority"] = 1] = "Authority";
    PayloadKey[PayloadKey["AuthoritySeeds"] = 2] = "AuthoritySeeds";
    PayloadKey[PayloadKey["Delegate"] = 3] = "Delegate";
    PayloadKey[PayloadKey["DelegateSeeds"] = 4] = "DelegateSeeds";
    PayloadKey[PayloadKey["Destination"] = 5] = "Destination";
    PayloadKey[PayloadKey["DestinationSeeds"] = 6] = "DestinationSeeds";
    PayloadKey[PayloadKey["Holder"] = 7] = "Holder";
    PayloadKey[PayloadKey["Source"] = 8] = "Source";
    PayloadKey[PayloadKey["SourceSeeds"] = 9] = "SourceSeeds";
})(PayloadKey = exports.PayloadKey || (exports.PayloadKey = {}));
function getPayloadKeySerializer() {
    return (0, serializers_1.scalarEnum)(PayloadKey, {
        description: 'PayloadKey',
    });
}
exports.getPayloadKeySerializer = getPayloadKeySerializer;
//# sourceMappingURL=payloadKey.js.map